import Link from 'next/link';
import styles from './NavMenu.module.css';

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

const NavMenu = () => {
    return (
        <nav className={styles.navMenu}>
            <ul>
                <li>
                    <Link href="/" aria-label='Acessar Página Home' onClick={scrollToTop}>
                        Home
                    </Link>
                </li>
                <li>
                    <Link href="/QuemSomos/" aria-label='Acessar Página Quem Somos' onClick={scrollToTop}>
                        Quem Somos
                    </Link>
                </li>
                <li>
                    <Link href="/Recursos/" aria-label='Acessar Página Recursos' onClick={scrollToTop}>
                        Recursos
                    </Link>
                </li>
                <li>
                    <Link href="/NossoAcervo/" aria-label='Conheça nosso Acervo' onClick={scrollToTop}>
                        Nosso Acervo
                    </Link>
                </li>
                <li>
                    <Link href="/Blog/" aria-label='Acessar Página Blog' onClick={scrollToTop}>
                        Blog
                    </Link>
                </li>
                <li>
                    <Link href="/Contato/" aria-label="Acessar Página Contato" onClick={scrollToTop}>
                        Contato
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default NavMenu;